"use client";

import { Typography } from "@/components/ui";
import { useGallery, UseGalleryProps } from "./use-gallery";
import { GalleryNav } from "./gallery-nav";
import { Photo } from "../photo";
import FsLightbox from "fslightbox-react";

export type GalleryProps = UseGalleryProps;

export const Gallery = (props: GalleryProps) => {
  const {
    className,
    styles,
    sliderRef,
    instanceRef,
    loaded,
    currentSlide,
    lightboxController,
    openLightboxImage,
    type,
    title,
    data,
  } = useGallery(props);

  return (
    <>
      <div className={styles.base({ className })}>
        <div className={styles.container()}>
          <div className={styles.heading()}>
            {!!title && (
              <Typography
                as="h3"
                className={styles.title()}
                fontSize="body-sm"
                fontWeight="bold"
                spacing="widest"
                uppercase
              >
                {title}
              </Typography>
            )}
            <GalleryNav
              styles={styles}
              instanceRef={instanceRef}
              loaded={loaded}
              currentSlide={currentSlide}
            />
          </div>
          <div ref={sliderRef} className={styles.gallery()}>
            {data.map((photo, index) => (
              <Photo
                className="keen-slider__slide"
                key={`gallery-${index}`}
                handleClick={() => openLightboxImage(index + 1)}
                type={type}
                data={photo}
              />
            ))}
          </div>
        </div>
      </div>
      <FsLightbox
        type="image"
        toggler={lightboxController.toggler}
        slide={lightboxController.slide}
        sources={data.map(({ image }) => image)}
      />
    </>
  );
};
